import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import Heading from '../../components/Typography/Heading/Heading';
import styles from './PrivateGuild.module.scss';
const PrivateGuild = () => {
    const { t } = useTranslation();
    return (_jsx("div", Object.assign({ className: styles.wrapper }, { children: _jsx(Heading, { className: styles.element, title: t('this_is_private_guild_sent_request_to_join') }) })));
};
export default PrivateGuild;
